import { get } from 'lodash-es';
export function jsonSafeParse(str, fallbackVal = undefined) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.warn(e);
    return fallbackVal;
  }
}
export function jsonSafeStringify(json, fallbackVal = '') {
  try {
    return JSON.stringify(json);
  } catch (e) {
    console.warn(e);
    return fallbackVal;
  }
}
export const toLowerCaseFirstLetter = str => str.charAt(0).toLowerCase() + str.slice(1);
export function getErrorMsg(val) {
  if (!val || typeof val === 'string') return val;
  return val.message || val.msg || val.status_msg;
}
export function isNullLike(val) {
  return val === null || val === undefined;
}
export function isLegalNum(val) {
  return !isNaN(val) && (val || val === 0);
}
export function id(val) {
  return val;
}
export function calcVal(val, ...$args) {
  if (typeof val === 'function') return val(...$args);
  return val;
}
export function changeURLArg(url, arg, arg_val) {
  const pattern = arg + '=([^&]*)';
  const replaceText = arg + '=' + arg_val;
  if (url.match(pattern)) {
    let tmp = '/(' + arg + '=)([^&]*)/gi';
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match('[?]')) {
      return url + '&' + replaceText;
    } else {
      return url + '?' + replaceText;
    }
  }
}
export function getNearestItemIndex(list, referNum, options) {
  if (!list?.length) return {
    sortList: [],
    index: -1
  };
  const calc = options?.calcCompareNum || Number;
  const $list = [...list].sort((a, b) => calc(a) - calc(b));

  // 二分法
  // 变量：leftCursor - 左边的索引，rightCursor - 右边的索引
  // 比较左右索引的中间元素与 referNum：
  //    如果中间元素比 referNum 大，则将 rightCursor 修改为中间元素的索引;
  //    如果中间元素比 referNum 小，则将 leftCursor 修改为中间元素的索引;
  //    如果中间元素与 referNum 相等，直接返回;
  // 直到 leftCursor 与 rightCursor 之间没有中间元素了
  const index = (() => {
    let leftCursor = 0;
    let rightCursor = $list.length - 1;
    while (rightCursor - leftCursor > 1) {
      const middle = Math.floor((rightCursor + leftCursor) / 2);
      const offset = referNum - calc($list[middle]);
      if (offset === 0) return middle;else if (offset < 0) rightCursor = middle;else leftCursor = middle;
    }
    const leftOffset = referNum - calc($list[leftCursor]);
    const rightOffset = referNum - calc($list[rightCursor]);
    if (leftOffset === 0) return leftCursor;
    if (leftOffset < 0) return options?.useLte ? -1 : leftCursor;
    if (rightOffset === 0) return rightCursor;
    if (rightOffset > 0) return options?.useGte ? rightCursor + 1 : rightCursor;
    if (options?.useGte) return rightCursor;
    if (options?.useLte) return leftCursor;
    return Math.abs(leftOffset) <= Math.abs(rightOffset) ? leftCursor : rightCursor;
  })();
  return {
    sortList: $list,
    index
  };
}
export function getNearestItem(list, referNum, options) {
  const {
    sortList,
    index
  } = getNearestItemIndex(list, referNum, options);
  return sortList[index];
}
export function calcMinAndMax(data, valueKey,
/**
 * @default { margin: [0.2, 0.2], integer: true }
 * */
options) {
  let $min = Infinity;
  let $max = -Infinity;
  data.forEach(it => {
    const val = valueKey ? +get(it, valueKey) : it;
    $min = Math.min($min, val);
    $max = Math.max($max, val);
  });
  const margin = isNullLike(options?.margin) ? [0.2, 0.2] : typeof options.margin === 'number' ? [options.margin, options.margin] : options.margin;
  const integer = options?.integer ?? true;
  const cvt = v => integer ? Math.floor(v) : v;
  return {
    min: Math.max(options?.min ?? -Infinity, cvt($min - ($max - $min) * margin[0])),
    max: Math.min(options?.max ?? Infinity, cvt($max + ($max - $min) * margin[1]))
  };
}
export function toQueryString(obj) {
  return Object.entries(obj).map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');
}